<template>
    <div class="search-bar-wrapper">
        <v-text-field
            append-outer-icon="search"
            class="search-box search"
            :label="$language.translate('Search products')"
            ref="searchInput"
            id="search"
        ></v-text-field>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';

const doofinderLayerConfig = {
    hashid: Vue.$config.DOOFINDER_ID,
    zone: 'eu1',
    display: {
        closeOnClick: true,
        closeIfEmpty: true,
        closeOnEscKey: true,
        lang: 'de',
        width: '100%',
        align: 'center',
        dtop: 78,
        facets: {
            attached: 'left',
        },
        mobile: {
            closeOnHit: true,
        },
    },
    callbacks: {},
    queryInput: '.search-bar-wrapper input',
};

export default {
    name: 'SearchBox',
    mounted() {
        const doofinderLayer = doofinderLayerConfig;
        let doofinderInstance = null;

        doofinderLayer.callbacks.loaded = instance => {
            doofinderInstance = instance;
        };

        doofinderLayer.callbacks.resultsReceived = () => {
            document.querySelectorAll('.df-card__main').forEach(el => {
                el.addEventListener('click', e => {
                    const url = new URL(el.href);
                    if (url.pathname !== undefined) {
                        e.preventDefault();
                        this.$router.push({
                            path: url.pathname,
                        });
                        doofinderInstance.layer.plugins.close.close();
                    }
                });
            });
        };

        if (!this.prerenderMode) {
            this.loadDoofinder(100, 10000, 'https://cdn.doofinder.com/media/js/doofinder-classic.7.latest.min.js', [
                doofinderLayer,
            ]);
        }
        if (window.doofinder) {
            window.doofinder.classic.setLayers([doofinderLayer]);
        }
    },
    computed: {
        ...mapState('PageContent', ['prerenderMode']),
    },
    methods: {
        loadDoofinderScript(url) {
            return new Promise(function(resolve, reject) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.id = 'doofinder-script';
                script.src = url;
                script.onload = resolve;
                script.onerror = reject;
                if (!document.getElementById(script.id)) {
                    document.head.appendChild(script);
                }
            })
                .then(() => {
                    return true;
                })
                .catch(error => console.log(error));
        },
        loadDoofinder(callInterval, delay, url, doofinderLayers) {
            if (!Vue.$config.DOOFINDER_ID) {
                console.error('Empty DOOFINDER_ID');
            }
            let that = this;
            let r,
                timeSpend,
                i = setInterval(function() {
                    timeSpend += callInterval;
                    r = typeof require === 'function';
                    if (timeSpend >= delay || r) clearInterval(i);
                    if (r) {
                        that.loadDoofinderScript(url)
                            .then(function() {
                                window.doofinder.classic.setLayers(doofinderLayers);
                            })
                            .catch(function(err) {
                                console.error('Something went wrong!', err);
                            });
                    }
                }, callInterval);
        },
    },
    watch: {
        $route(to, from) {
            if (this.queryParsed === false) {
                this.queryParsed = true;
                this.query = to.params.query;
            } else if (this.queryParsed && !to.params.hasOwnProperty('query')) {
                this.query = '';
            }
        },
    },
};
</script>
